import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorService } from 'src/app/services/error.service';
import {
  DesApiKeyLink,
  DESCreditRecord,
  MachinesService,
} from 'src/app/services/machines.service';

@Component({
  selector: 'app-des-credits-page',
  templateUrl: './des-credits-page.component.html',
  styleUrl: './des-credits-page.component.scss',
})
export class DesCreditsPageComponent {
  records: DESCreditRecord[] = [];
  desApiKeyLink?: DesApiKeyLink;
  loading = false;
  error = '';

  constructor(
    private authService: AuthService,
    private errorService: ErrorService,
    private machinesService: MachinesService,
    private router: Router
  ) {
    this.loadRecords();
  }

  loadRecords() {
    const tenantId = this.authService.currentUser?.tenant_id;
    if (!tenantId) {
      this.error = 'Unable to load DES credit records.';
      return;
    }
    this.loading = true;
    this.error = '';
    this.machinesService.getMachinesForTenant(tenantId).subscribe({
      next: (res) => {
        this.loading = false;
        this.records = [...(res.des_credits ?? [])].sort(
          (a, b) => a.registration_id - b.registration_id
        );
        this.desApiKeyLink = res.des_api_key_link;
      },
      error: (err) => {
        this.loading = false;
        this.records = [];
        this.desApiKeyLink = undefined;
        this.error =
          this.errorService.getErrorMessage(err) ||
          'Unable to load DES credit records.';
      },
    });
  }

  get isApiCustomer(): boolean {
    return this.desApiKeyLink?.has_api_key === true;
  }

  get notLinkedMessage(): string {
    return 'API Key is not linked to DES Credit record';
  }

  get multipleLinksWarning(): string {
    return 'Warning: multiple DES Key links exist';
  }

  get showMultipleLinks(): boolean {
    if (this.loading || this.error || this.desApiKeyLink?.lookup_error) {
      return false;
    }
    return (
      this.isApiCustomer && this.desApiKeyLink?.multiple_link_records === true
    );
  }

  get showNotLinked(): boolean {
    if (this.loading || this.error || this.desApiKeyLink?.lookup_error) {
      return false;
    }
    if (!this.isApiCustomer || this.showMultipleLinks) {
      return false;
    }
    if (this.desApiKeyLink?.linked_to_des_credit) {
      return false;
    }
    return this.records.some((r) => r.linked_to_api_key) === false;
  }

  wholeCredit(raw?: string | null): number | null {
    const s = String(raw ?? '').trim();
    if (!s) {
      return null;
    }
    const n = Number(s);
    return Number.isFinite(n) ? Math.round(n) : null;
  }

  displayCredit(rec: DESCreditRecord): string {
    const n = this.wholeCredit(rec.credit);
    return n === null ? '—' : String(n);
  }

  buyCredits(rec: DESCreditRecord) {
    this.router.navigate(['/buy-des-credits'], {
      queryParams: { registration_id: rec.registration_id },
    });
  }
}
